import { useState, useEffect } from 'react'

const STORAGE_KEY = 'adios_azucar_countdown_expiry'
const DURATION_MINUTES = 10

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState<{
    hours: number
    minutes: number
    seconds: number
    isExpired: boolean
  }>({ hours: 0, minutes: 0, seconds: 0, isExpired: false })

  useEffect(() => {
    // Initialize expiry time
    let expiryTime = localStorage.getItem(STORAGE_KEY)

    if (!expiryTime) {
      const now = new Date()
      const expiry = new Date(now.getTime() + DURATION_MINUTES * 60 * 1000)
      expiryTime = expiry.toISOString()
      localStorage.setItem(STORAGE_KEY, expiryTime)
    }

    const interval = setInterval(() => {
      const now = new Date()
      const end = new Date(expiryTime!)
      const diff = end.getTime() - now.getTime()

      if (diff <= 0) {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0, isExpired: true })
        // Optional: Reset timer for demo purposes or keep expired
        // For scarcity, keeping it expired or restarting is a business decision.
        // Here we'll just clamp at 0.
      } else {
        const hours = Math.floor(
          (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
        )
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((diff % (1000 * 60)) / 1000)

        setTimeLeft({ hours, minutes, seconds, isExpired: false })
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return timeLeft
}
